import { render, staticRenderFns } from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=template&id=22aadba9&scoped=true"
import script from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=script&lang=js"
export * from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.ExtractPhoneNumber.vue?vue&type=style&index=0&id=22aadba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aadba9",
  null
  
)

export default component.exports